/**
 * Copy aprovada do estado "XML do CT-e indisponível" na linha Tracking do painel
 * de Expedição (TMS-7192 — seção "Copy proposta" da descrição do card).
 *
 * As strings abaixo são LITERAIS. Não parafrasear, não ajustar pontuação, não
 * trocar travessão (—) por hífen. Mudar qualquer uma é mudança de produto.
 *
 * Sem terceiros e com extensão `.js` nos imports: o harness
 * `tools/verificar-xml-cte-indisponivel.mjs` espelha este módulo num diretório
 * temporário ESM.
 */

export const TITULO = "Nota não enviada ao rastreamento: XML do CT-e indisponível";

export const CORPO =
  "O CT-e desta nota foi gravado sem o arquivo XML, e o envio ao iTrack depende dele. Reenviar não resolve — o arquivo precisa ser recuperado junto à NSTech pela equipe técnica. Abra chamado informando a carga e o número do CT-e.";

/**
 * Não há integração com Service Desk neste repositório: a ação copia o bloco já
 * preenchido (carga, nota, CT-e) para a área de transferência — mesmo mecanismo
 * do TMS-8396, cujo rótulo é "Abrir chamado com estes dados".
 */
export const ACAO_ABRIR_CHAMADO = "Abrir chamado";

export const DETALHES_TECNICOS_TITULO = "Detalhes técnicos";

/* Rótulos dos detalhes: nomes técnicos literais da copy — o chamado segue para a engenharia. */
export const ROTULO_CARGA_ID = "carga_id";
export const ROTULO_DOCFIS_ID = "docfis_id";
export const ROTULO_DOCCTE_ID = "doccte_id";
export const ROTULO_HORARIO_ULTIMA_TENTATIVA = "Horário da última tentativa";
/* Aparece só quando o grupo tem mais notas do que CT-es listados (o backend lista no máximo 10). */
export const ROTULO_CTES_LISTADOS = "CT-es listados";

/* Bloco copiado para a área de transferência (rótulos operacionais, não são copy de tela). */
export const CHAMADO_DETALHES_TITULO = "Detalhes técnicos:";
export const ROTULO_CHAMADO_CARGA = "Carga";
export const ROTULO_CHAMADO_NOTA = "Nota";
export const ROTULO_CHAMADO_CTE = "CT-e";
